import { Page } from 'components';
import { Head, PageWrapper } from 'layouts';
import { GetStaticProps, NextPage } from 'next';
import { getPageData, GetPageDataReturnData } from '../../lib/posts';
import { ParsedUrlQuery } from 'querystring';

type GetStaticPropsReturnType = GetPageDataReturnData & Record<string, unknown>;

const PaginatedView: NextPage<GetStaticPropsReturnType> = (props) => {
  return (
    <PageWrapper>
      <Head
        title="LANDR Blog: Music Production, Mixing, Creativity"
        description="LANDR is professional mastering for music creators. Our blog is a place to read up on music production, mixing and creativity."
      />
      <Page {...props} />
    </PageWrapper>
  );
};

export async function getStaticPaths() {
  return {
    paths: [
      // TODO: bring back when Apollo is using GET requests
      // '/en/page/1',
      // '/en/page/2',
      // '/en/page/3',
      // '/fr/page/1',
      // '/fr/page/2',
      // '/fr/page/3',
      // '/de/page/1',
      // '/de/page/2',
      // '/de/page/3',
      // '/ja/page/1',
      // '/ja/page/2',
      // '/ja/page/3',
      // '/es/page/1',
      // '/es/page/2',
      // '/es/page/3',
      // '/pt-br/page/1',
      // '/pt-br/page/2',
      // '/pt-br/page/3',
      // '/it/page/1',
      // '/it/page/2',
      // '/it/page/3',
    ],
    fallback: 'blocking',
  };
}

export interface PageParams extends ParsedUrlQuery {
  page: string;
}

export const getStaticProps: GetStaticProps<
  GetStaticPropsReturnType,
  PageParams
> = async (props) => {
  const { posts, totalAmountOfPosts, page, error } = await getPageData(props);

  return {
    props: {
      error,
      page,
      posts,
      totalAmountOfPosts,
    },
    revalidate: 3600, // 1 hour
  };
};

export default PaginatedView;
